import { render } from "./Testimonials.vue?vue&type=template&id=622e7697&scoped=true"
import script from "./Testimonials.vue?vue&type=script&lang=ts"
export * from "./Testimonials.vue?vue&type=script&lang=ts"

import "./Testimonials.vue?vue&type=style&index=0&id=622e7697&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-622e7697"

export default script